import * as React from "react";
import type { SVGProps } from "react";
const SvgMessageText01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8.4 8.4h7.199m-7.2 4.8h4.2m9-1.2c0 1.38-.291 2.692-.815 3.878l.817 5.721-4.903-1.226a9.56 9.56 0 0 1-4.699 1.227 9.6 9.6 0 1 1 9.6-9.6"
    />
  </svg>
);
export default SvgMessageText01;
